import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';

export function useProformaInvoiceUrlMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (chargifyCustomerId: number): Promise<string> => {
			return new Promise((resolve, reject) => {
				const onFinish = (opResult: Api.IOperationResult<string>) => {
					if (opResult.success && opResult.value) {
						resolve(opResult.value);
					} else {
						reject(new Error(opResult.systemMessage || 'Failed to get proforma invoice URL'));
					}
				};
				userSession.webServiceHelper.callWebServiceWithOperationResults<string>(
					`admin/BillingUtilities/GetProformaInvoiceUrl?chargifyCustomerId=${encodeURIComponent(chargifyCustomerId)}`,
					'GET',
					null,
					onFinish,
					onFinish
				);
			});
		},
	});
}
